import { apiDelete } from "../baseApi";

export const deleteById = async (id,data={}, cancelToken = null) => {
  try {
    const response = await apiDelete("_district", id, data, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
